import { ref } from 'vue';
import { adicionarAnexos, nomearPrintColado } from './helpers';

// Anexos de um formulário (abertura ou resposta): escolha, arrastar, colar e recusas.
// `anexos` pode vir de fora, para sobreviver ao componente (rascunho da abertura).
export function useAnexos(anexos = ref([])) {
  const recusas = ref([]);

  const adicionar = arquivos => {
    const resultado = adicionarAnexos(anexos.value, Array.from(arquivos));
    anexos.value = resultado.aceitos;
    recusas.value = resultado.recusas;
  };

  const remover = indice => {
    anexos.value = anexos.value.filter((_, i) => i !== indice);
    recusas.value = [];
  };

  const limpar = () => {
    anexos.value = [];
    recusas.value = [];
  };

  // Ctrl+V de um print vira anexo; texto colado segue normal para a caixa.
  const aoColar = evento => {
    const arquivos = Array.from(evento.clipboardData?.files || []);
    if (!arquivos.length) return;
    evento.preventDefault();
    adicionar(
      arquivos.map(arquivo =>
        arquivo.type.startsWith('image/') ? nomearPrintColado(arquivo) : arquivo
      )
    );
  };

  return { anexos, recusas, adicionar, remover, limpar, aoColar };
}
